export var LINK_TYPES = {
  BUTTON: 'BUTTON',
  LINK: 'LINK'
};
export var TRK_PRODUCT_LOCATION = 'MarketplaceReviewLink';